import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--down",
  "use": "icon-arrow--down-usage",
  "viewBox": "0 0 10 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 18\" id=\"icon-arrow--down\"><path d=\"M10 12.58a.6.6 0 0 0-1.042-.375L5.604 15.86V.631a.623.623 0 0 0-.63-.63.623.623 0 0 0-.567.63v15.23l-3.349-3.656a.6.6 0 1 0-.879.81l4.39 4.793a.598.598 0 0 0 .879 0l4.39-4.792a.598.598 0 0 0 .161-.437Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol